'use client';

import { c as _c } from "react/compiler-runtime";
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import { AddedToCart } from '@feat/feat-cart/added-to-cart';
import { useAppAccommodationConfigModal } from '../_hooks/app-use-config-modal';
import { useAppAccommodationRecommendations } from '../_hooks/use-app-accommodation-recommendations';
import { useAppAccommodationSearch } from '../_hooks/use-app-accommodation-search';
import { getAccommodationRoomsUrl } from '../_lib/accommodation-booking-box';
import type { AccommodationDetailData } from '../_lib/accommodation-server';
import { AppAccommodationBookingBoxDesktop } from './app-accommodation-booking-box-desktop';
import { AppAccommodationBookingBoxMobile } from './app-accommodation-booking-box-mobile';
import { useAppAccommodationBookingBoxContext } from './app-accommodation-booking-box-provider';
import { AppAccommodationConfigModal } from './app-accommodation-config-modal';
import { AppAccommodationRatesContainer } from './app-accommodation-rates-container';
type AppAccommodationBookingBoxProps = {
  accommodation: AccommodationDetailData;
};
export function AppAccommodationBookingBox(t0) {
  const $ = _c(36);
  const {
    accommodation
  } = t0;
  const isMobile = useMediaState("mobile");
  const isSingleRoom = !!accommodation.room;
  const {
    showRoomRatesModal
  } = useAppAccommodationBookingBoxContext();
  const {
    recommendation
  } = useAppAccommodationRecommendations(accommodation.id);
  const {
    data: accommodationSearch,
    isLoading,
    isPending,
    isError
  } = useAppAccommodationSearch(accommodation.id);
  const {
    activeContent,
    handleBackClick,
    handleClose,
    handleDateSubmit,
    handlePaxSubmit,
    isDateSubmitPending
  } = useAppAccommodationConfigModal();
  const bestPrice = accommodationSearch?.data[0]?.pricing;
  let t1;
  if ($[0] !== accommodation || $[1] !== bestPrice || $[2] !== isError || $[3] !== isLoading || $[4] !== isPending) {
    t1 = <div className="hidden sm:contents"><div className="sticky-top-offset-12 sticky"><AppAccommodationBookingBoxDesktop accommodation={accommodation} bestPrice={bestPrice} isLoading={isLoading} isPending={isPending} isError={isError} /></div></div>;
    $[0] = accommodation;
    $[1] = bestPrice;
    $[2] = isError;
    $[3] = isLoading;
    $[4] = isPending;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== accommodation.currency || $[7] !== accommodation.id || $[8] !== accommodation.slug || $[9] !== bestPrice || $[10] !== isLoading || $[11] !== isPending || $[12] !== isSingleRoom) {
    t2 = <div className="sm:hidden"><AppAccommodationBookingBoxMobile bestPrice={bestPrice} id={accommodation.id} slug={accommodation.slug} currency={accommodation.currency} isLoading={isLoading} isPending={isPending} isSingleRoom={isSingleRoom} /></div>;
    $[6] = accommodation.currency;
    $[7] = accommodation.id;
    $[8] = accommodation.slug;
    $[9] = bestPrice;
    $[10] = isLoading;
    $[11] = isPending;
    $[12] = isSingleRoom;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== accommodation || $[15] !== activeContent || $[16] !== handleBackClick || $[17] !== handleClose || $[18] !== handleDateSubmit || $[19] !== handlePaxSubmit || $[20] !== isDateSubmitPending || $[21] !== isMobile || $[22] !== isSingleRoom) {
    t3 = activeContent && <AppAccommodationConfigModal accommodation={accommodation} activeContent={activeContent} slides={isMobile} isSubmitting={isDateSubmitPending} showRoomsPicker={!isSingleRoom} onPaxSubmit={handlePaxSubmit} onDateSubmit={config => {
      handleDateSubmit(config, isSingleRoom, getAccommodationRoomsUrl(accommodation.id, accommodation.slug));
    }} onBackClick={handleBackClick} onClose={handleClose} />;
    $[14] = accommodation;
    $[15] = activeContent;
    $[16] = handleBackClick;
    $[17] = handleClose;
    $[18] = handleDateSubmit;
    $[19] = handlePaxSubmit;
    $[20] = isDateSubmitPending;
    $[21] = isMobile;
    $[22] = isSingleRoom;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== accommodation || $[25] !== showRoomRatesModal) {
    t4 = showRoomRatesModal && <AppAccommodationRatesContainer accommodation={accommodation} />;
    $[24] = accommodation;
    $[25] = showRoomRatesModal;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  let t5;
  if ($[27] !== isSingleRoom || $[28] !== recommendation) {
    t5 = isSingleRoom && <AddedToCart recommendation={recommendation || null} />;
    $[27] = isSingleRoom;
    $[28] = recommendation;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== t1 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t5) {
    t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
    $[30] = t1;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t5;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  return t6;
}